export const locale_es_ES = {};
